// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleProduct from './routes/single-product';

// Additional Libraries
import { setupCookieNoticePopup } from './modules/cookie-notice';
import { rerunGravityFormsScripts } from './modules/forms';

// Swup setup
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import BoneCustomSwupUpdater from './modules/bone-custom-swup-updater';
import GlobalMeasurements from './modules/global-measurements';
import { globalModals } from './modules/modals';
import SidebarNav from './modules/sidebar-nav';
import Ajax_Minicart from './modules/wc-ajax-minicart';
import WCCheckout from './modules/wc-checkout';
import PageFlow from './modules/page-flow';
import SearchBar from './modules/search-bar';
import PostCarousels from './modules/post-carousels';
import { EnquirySelectedSetup, initTracking } from './modules/tracking';


const options = {
	linkSelector: `a[href^="${window.location.origin}"]:not([data-no-swup]):not([target="_blank"]), a[href^="/"]:not([data-no-swup]):not([target="_blank"]), a[href^="#"]:not([data-no-swup]):not([target="_blank"])`,
	plugins: [
		new SwupBodyClassPlugin(),
		new SwupScrollPlugin({
			doScrollingRightAway: false,
			animateScroll: false,
		}),
		new BoneCustomSwupUpdater(),
	],
	animateHistoryBrowsing: true,
	containers: [
		'#body-wrapper',
	],
	animationSelector: '[class*="swup-page-loader"]',
	cache: false,
};

export const swup = new Swup(options);

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,
	// Home page
	home,
	// Single product pages
	// singleProduct,
});

swup.on('pageView', () => {
	initTracking();
});

// Generic events - these are loaded once only and would not re-run on Swup page changes
jQuery(document).ready(() => {
	// Place one off code here - such as click events for the menu
	setupCookieNoticePopup();
	// globalModals();
	// menuModal();
	initTracking();
	GlobalMeasurements.start();
	SidebarNav.init();
	Ajax_Minicart.init();
	WCCheckout.init();
	PageFlow.init();
	SearchBar.init();
	PostCarousels.init();
});

// Load Events
jQuery(document).on('ready', () => routes.loadEvents());

// Load Events when using Swup
swup.on('contentReplaced', () => {
	rerunGravityFormsScripts();
	routes.loadEvents()
	WCCheckout.init();
	PageFlow.init();
	PostCarousels.init();
});


swup.on('willReplaceContent', () => {
	routes.unloadEvents()
	PageFlow.unload();
});

// Tracking Event for Form submission - should be here so it only runs once
jQuery(document).on('gform_confirmation_loaded', function(event, formId){
	const enquiryFormId = 11;
	if(formId == enquiryFormId)
	{
		// Product Enquiry Form Event
		EnquirySelectedSetup();
	}
});



// WEBPACK FOOTER //
// ./scripts/main.js